module.exports = __webpack_public_path__ + "1c647b53dd29a80cc7f31b74089eef0a.pdf";